export default __webpack_public_path__ + "static/media/Spotify_logo_with_text.4f8bc335.svg";